export class LoginSettingsUpdateRequest {
    PhotoId: string;
    Color: string;
    Overlay?: number;
}